// extracted by mini-css-extract-plugin
module.exports = {"survey":"SurveyList_survey__fL1Ab","finishItemContainer":"SurveyList_finishItemContainer__CKjT9"};